import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
  inject
} from '@angular/core';
import { getSecondsFromDate } from 'mbs-ui-shared@utils';

@Component({
  selector: 'mbs-tfa-timer',
  templateUrl: './tfa-timer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  standalone: true,
  host: {
    '(window:focus)': 'onFocus()'
  }
})
export class TfaTimerComponent implements OnChanges {
  private cdr = inject(ChangeDetectorRef);

  @Input() expiredDate: string | Date;
  @Input() template: TemplateRef<any>;

  @Output() dateExpired = new EventEmitter();

  public time = 0;

  private interval: NodeJS.Timeout;

  onFocus(): void {
    this.startTimer();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.startTimer();
  }

  private pauseTimer(): void {
    clearInterval(this.interval);
  }

  private startTimer(): void {
    this.pauseTimer();

    this.time = getSecondsFromDate(this.expiredDate);

    if (this.isExpiredDate()) {
      this.onDateExpired();
      this.cdr.detectChanges();
      return;
    }

    this.interval = setInterval(() => {
      if (this.isExpiredDate()) {
        this.onDateExpired();
      } else {
        this.time--;
      }
      this.cdr.detectChanges();
    }, 1000);
  }

  private isExpiredDate() {
    return this.time < 1;
  }

  private onDateExpired() {
    this.dateExpired.emit();
    this.pauseTimer();
  }
}
